var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultipleUsers = function SvgMultipleUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M42.5 50c0-7-8.75-7.5-12.5-7.5S17.5 43 17.5 50m35-7.5c0-2.344-1.538-6.886-7.5-7.443M15 35c-7.5 0-7.5 6.25-7.5 7.5M45 26.25c10-10-3.75-18.854-10-12.5m-20 12.5c-8.75-6.25 1.25-20 10-12.5M37.5 27.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0"
  })));
};
export default SvgMultipleUsers;